import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
//import FormatAlignJustifyIcon from "@mui/icons-material/FormatAlignJustify";
import PermDataSetting from "@mui/icons-material/PermDataSetting";
import {
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BasicAccordion from "./BasicAccordion";
import SaveIcon from "@mui/icons-material/Save";
import { useDispatch, useSelector } from "react-redux";
import {
  getDSAData,
  setState,
  localForecastDataAlignmentCheck,
} from "./editScenarioNewSlice";
import { sizes } from "./editScenarioNewUtils";
import { auto } from "@popperjs/core";


const LW = sizes.w650;
const commonHeight = sizes.h35;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vw",
  height: "80vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
};

export default function BasicModal() {
   const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const {
    scenarioName,
    selectedPGs,
    selectedPG_SKU_ADSs,
    selectedDSs,
    dataSources,
    countryID,
    isLoadingEdit,
    DSAIdString,
    selectedPDS,
    scDSA,
    scDSACopy,    
    isLoadingAlignment,
    isLoadingAlignmentperSKU
  } = useSelector((store) => store.editScenarioNew);
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    dispatch(setState("scDSA", scDSACopy));
    dispatch(setState("premidasFilterParameters", []));
    dispatch(setState("midasFilterParameters", []));
    dispatch(setState("prelocalFilterParameters", []));
    dispatch(setState("preLocalFilterParameterList", []));
    dispatch(setState("localFilterParameters", []));
  };
  const handleSave = () => {
    setOpen(false);
    dispatch(setState("scDSACopy", scDSA));
  };

  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };

  const handleSKU_PG = (event) => {
    const sku_pg = event.target.value;
    const sku_pg_obj = selectedPGs.find(
      (obj) =>
        obj.name === sku_pg ||
        obj.productGroupName === sku_pg ||
        obj.productName === sku_pg
    );
    const sku_pgID =
      sku_pg_obj.id || sku_pg_obj.productGroupID || sku_pg_obj.productID;
    dispatch(setState("selectedPG_SKU_ADSs", sku_pg));
    dispatch(setState("selectedPG_SKU_ADSsID", sku_pgID));
  };

  const getIdString = () => {
    let idString = "";
    for (let i = 0; i < selectedDSs.length; ++i) {
      const name = selectedDSs[i];
      const id = dataSources.find(
        (dS) => dS.dataSourceName === name
      ).dataSourceID;
      idString += i === selectedDSs.length - 1 ? id : id + "|";
    }
    return idString;
  };

  const handleAlignDataSources = () => {
    if (selectedPGs.length <= 0) {
      showMessage("Please select at least one sku or product group", "info");
      return;
    }
    if (selectedPDS.length <= 0) {
      showMessage("Please select a primary data source", "info");
      return;
    }
    handleOpen();
    let sku_list = selectedPGs
      .filter((obj) => obj.type === "P" || obj.hasOwnProperty("productID"))
      .map((obj) => (obj.id ? obj.id : obj.productID));
    let pg_list = selectedPGs
      .filter(
        (obj) => obj.type === "PG" || obj.hasOwnProperty("productGroupID")
      )
      .map((obj) => (obj.id ? obj.id : obj.productGroupID));
    const skuCustList = {
      SKUIDList: sku_list,
      productGroupIdList: pg_list,
      Geoid: countryID,
    };
    const idString = getIdString();
    if (selectedPGs.length > 0 && idString !== DSAIdString) {
      dispatch(setState("DSAIdString", idString));
      dispatch(setState("DSAIdStringPrev", DSAIdString));
      dispatch(getDSAData({ countryID, idString })).then(()=>{
        dispatch(localForecastDataAlignmentCheck(skuCustList));
      });
    }
    else if(selectedPGs.length > 0){
      dispatch(localForecastDataAlignmentCheck(skuCustList));
    }
    if (idString === DSAIdString) {
      dispatch(setState("DSAIdString", idString));
      dispatch(setState("DSAIdStringPrev", DSAIdString));
    }
    dispatch(setState("selectedPG_SKU_ADSs", null));
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Button
        startIcon={<PermDataSetting />}
        sx={{
          bgcolor: "darkBlue.light",
          color: "white.main",
          textTransform: "none",
          "&:hover": {
            bgcolor: "darkBlue.main",
          },
        }}
        onClick={handleAlignDataSources}
      >
        Align data sources
      </Button>

      {isLoadingEdit ? (
        <Box>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={isLoadingEdit}
          >
            <CircularProgress />
          </Backdrop>
        </Box>
      ) : (
        <Box>
        <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 999 }}
        open={isLoadingAlignment || isLoadingAlignmentperSKU}
        >
        <CircularProgress />
        </Backdrop>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{ color: "darkBlue.light" }}
                variant="subtitle2"
                fontSize={18}
                fontWeight={700}
                width={"97%"}
              >
                Define and Link Data Sources
              </Typography>
              <Button
                className="closeButton"
                sx={{ minWidth: "30px !important", ml: 4 }}
                startIcon={
                  <CloseIcon
                    sx={{ color: "black.main", minWidth: "10px !important" }}
                  />
                }
                onClick={handleClose}
              ></Button>
            </Box>

            <Divider sx={{ mt: 2 }} />

            <Box>
              <Typography variant="subtitle2" fontSize={16} mt={2}>
                Scenario: {scenarioName}
              </Typography>
            </Box>

            <Box sx={{ mt: 3 }}>
              <FormControl>
                <InputLabel id="demo-simple-select-label">
                  SKU/Product group
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedPG_SKU_ADSs}
                  label="SKU/Product group"
                  sx={{
                    height: commonHeight,
                    width: LW,
                    color: "black.main",
                    mt: 1,
                  }}
                  onChange={(event) => handleSKU_PG(event)}
                >
                  {selectedPGs.map((pg, index) => {
                    return (
                      <MenuItem
                        key={index}
                        value={pg.name || pg.productGroupName || pg.productName}
                      >
                        {pg.name || pg.productGroupName || pg.productName}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>

            {selectedPG_SKU_ADSs?.length > 0 && (
              <Box
                sx={{ mt: 3 }}
              >
                <BasicAccordion />
              </Box>
            )}

            <Box>
              <Button
                startIcon={<SaveIcon />}
                sx={{
                  bgcolor: "darkBlue.light",
                  color: "white.main",
                  textTransform: "none",
                  mt: 2,
                  "&:hover": {
                    bgcolor: "darkBlue.main",
                  },
                  marginLeft: "calc(100% - 115px)",
                }}
                disabled={!isRestrictedAccess}
                onClick={handleSave}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Modal>
        </Box>
      )}
    </Box>
  );
}
